var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalComponent',{attrs:{"name":"imagen-panoramica","title":_vm.title},on:{"close":() => _vm.close(false)}},[_c('iframe',{staticStyle:{"border-style":"none","width":"100%"},attrs:{"height":"400","allowfullscreen":"","src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }